<div class="router-bar">
  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/categories'}">
    <button mat-button [routerLink]="['/admin-panel/categories']">Category/Multiplication Editor</button>
  </div>
<!--  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/modifiers'}">-->
<!--    <button mat-button [routerLink]="['/admin-panel/modifiers']">Modifiers Editor</button>-->
<!--  </div>-->
  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/grades'}">
    <button mat-button [routerLink]="['/admin-panel/grades']">Grade Editor</button>
  </div>
  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/items'}">
    <button mat-button [routerLink]="['/admin-panel/items']">Item Editor</button>
  </div>
  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/emails'}">
    <button mat-button [routerLink]="['/admin-panel/emails']">Email Templates</button>
  </div>

  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/dictionaries'}">
    <button mat-button [routerLink]="['/admin-panel/dictionaries']">Dictionaries</button>
  </div>

  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/activities'}">
    <button mat-button [routerLink]="['/admin-panel/activities']">Activities</button>
  </div>

  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/kb-columns'}">
    <button mat-button [routerLink]="['/admin-panel/kb-columns']">KB Columns</button>
  </div>

  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/nfs-alerts'}">
    <button mat-button [routerLink]="['/admin-panel/nfs-alerts']">Nfs/Alerts</button>
  </div>

  <div class="admin-button-route" [ngClass]="{'current-route': router.url === '/admin-panel/access'}">
    <button mat-button [routerLink]="['/admin-panel/access']">Access</button>
  </div>
</div>

<div class="admin-panel-middle">
  <router-outlet></router-outlet>
</div>
